<template>
	<div class="cards-container">
		<div class="help-banner" @click="collapsed = !collapsed">
			<p>{{ getString('do_you_need_help') }}</p>
			<AppChevronIcon :direction="collapsed ? 'down' : 'up'" />
		</div>
		<AppDropdown :collapsed="collapsed" white>
			<div class="cards-inner-container">
				<div class="card card-upload" @click.stop="goCheckoutMenu">
					<div class="card-left">
						<div class="title">{{ getString('upload_menu_service', [userStore.menuWord]) }}</div>
						<div class="description">{{ getString('upload_menu_service_details', [userStore.menuWord]) }}</div>
						<div class="special">{{ getString('upload_menu_service_special') }}<span class="klarna"><img src="https://img.qromo.io/img/icons/klarna-logo.svg"></span></div>
						<div class="price"><span class="slashed">{{ fullPriceLoadMenu }}</span> {{ getString('price_vat', [currPriceLoadMenu]) }}</div>
					</div>
					<div class="card-right">
						<div class="card-image"><img src="https://img.qromo.io/img/menu-upload.jpg" alt=""><p class="absolute-cta" v-if="!loadingMenu">{{ getString('start_now') }}</p><AppLoader class="absolute-loader mr-10 mb-10" :size="30" color="#fff" v-if="loadingMenu"/></div>
					</div>
					<div class="most-popular">{{ getString('most_popular') }}</div>
				</div>
				<div class="card" @click="openTutorialBlank" v-if="countryIsIT">
					<div class="card-left">
						<div class="title">{{ getString('help_card_title') }}</div>
						<div class="description">{{ getString('help_card_description', [userStore.menuWord]) }}</div>
					</div>
					<div class="card-right">
						<div class="card-image"><img src="https://img.qromo.io/img/menu-help.jpg" alt=""><p class="absolute-cta">{{ getString('tutorial') }}</p></div>
					</div>
				</div>
			</div>
		</AppDropdown>
		<CheckoutInPlace :client-secret="clientSecret" @toggling-popup="togglingPopupSheet" @checkout-complete="paymentComplete" />
	</div>
</template>

<script>
import {useLanguageStore, useNotificationStore, useCurrencyStore} from "@/shared/stores";
import {useUserStore} from "@/console-new/stores";
import AppLoader from "@/shared/components/AppLoader.vue";
import AppDropdown from "@/shared/components/AppDropdown.vue";
import AppChevronIcon from "@/shared/components/AppChevronIcon.vue";
import CheckoutInPlace from "@/console-new/components/shared/CheckoutInPlace.vue";

export default {
	components: {CheckoutInPlace, AppChevronIcon, AppDropdown, AppLoader},
	setup() {
		let languageStore = useLanguageStore();
		let userStore = useUserStore();
		let notificationStore = useNotificationStore();
		let currencyStore = useCurrencyStore();
		return {
			getString: languageStore.getString,
			userStore,
			currencyStore,
			notificationStore
		};
	},
	name: "CardsHelp",
	data() {
		return {
			loadingMenu: false,
			collapsed: true,
			clientSecret: null,
		};
	},
	computed: {
		currPriceLoadMenu() {
			return this.currencyStore.readableCurrencyValue(this.currencyStore.currCurrency.prices.load_menu.amount, false);
		},
		fullPriceLoadMenu() {
			return this.currencyStore.readableCurrencyValue(this.currencyStore.currCurrency.prices.load_menu.full_price, false);
		},
		countryIsIT() {
			return this.userStore.currBusiness && this.userStore.currBusiness.country === "IT";
		}
	},
	methods: {
		goCheckoutMenu() {
			if(this.loadingMenu) return;
			this.loadingMenu = true;
			this.userStore.stripeUploadMenuService((result, details) => {
				this.loadingMenu = false;
				if(!result) {
					if(details && details === 'currency_mismatch') {
						this.showNotification("user-currency-mismatch", [this.userStore?.user?.name]);
					} else {
						this.showNotification("generic-fail");
					}
				} else {
					this.clientSecret = result;
				}
			});
		},
		openTutorialBlank() {
			window.open('https://qromo-help.freshdesk.com/support/solutions/articles/202000100894-anagrafica-prodotti', '_blank');
		},
		togglingPopupSheet(v) {
			if(!v) {
				this.clientSecret = null;
			}
		},
		paymentComplete() {
			setTimeout(() => {
				this.clientSecret = null;
			}, 2500);
		}
	}
}
</script>

<style scoped lang="scss">
:deep(.dropdown) {
	background-color: var(--color-bg-primary-1);
	border-radius: 13px;
}
.cards-container {
	margin-right: 20px;
	margin-left: 8px;
	.cards-inner-container {
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		align-items: stretch;
		gap: 12px;
	}

	@media (max-width: 768px) {
		margin-right: 8px;
	}

	.help-banner {
		width: 100%;
		background-color: var(--color-bg-primary-2);
		padding: 7px 12px;
		display: flex;
		justify-content: space-between;
		align-items: center;
		border-radius: 13px;
		cursor: pointer;

		p {
			font-size: 14px;
			//color: #9B9B9B;
		}
	}

	.card {
		display: flex;
		flex-direction: row;
		justify-content: center;
		align-items: stretch;
		padding: 10px;
		border-radius: 13px;
		background-color: var(--color-bg);
		box-shadow: 0 1px 5px var(--color-box-shadow-3);
		flex: 1 0 calc(50% - 10px);
		cursor: pointer;

		.card-left {
			width: 60%;
			display: flex;
			flex-direction: column;
			justify-content: flex-start;
			align-items: flex-start;
			padding-right: 15px;

			.title {
				font-size: 18px;
				font-weight: 600;
				color: var(--color-primary);
				margin-bottom: 10px;
			}

			.description {
				font-size: 13px;
				font-weight: 400;
				color: var(--txt-1);
				margin-bottom: 10px;
			}

			.special {
				font-size: 11px;
				font-weight: 400;
				color: var(--txt-1);
				margin-bottom: 10px;
				display: flex;
				align-items: center;

				.klarna {
					margin-left: 10px;
					display: flex;
					align-items: center;

					img {
						width: 40px;
					}
				}
			}

			.price {
				font-size: 14px;
				font-weight: 500;
				color: #0852A2;
				display: flex;
				align-items: center;

				.slashed {
					font-weight: 600;
					text-decoration: line-through;
					margin-right: 10px;
					color: #0852A2;
					font-size: 20px;
				}
			}
		}

		.card-right {
			width: 40%;
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;

			.card-image {
				width: 100%;
				height: 100%;
				position: relative;
				display: flex;
				justify-content: center;
				align-items: center;

				img {
					width: 100%;
					height: 100%;
					border-radius: 13px;
					object-fit: cover;
				}

				.absolute-cta {
					position: absolute;
					bottom: 0;
					right: 0;
					font-size: 14px;
					font-weight: 700;
					color: var(--color-bg);
					padding: 5px 12px;
					z-index: 10;
					text-align: right;
				}

				.absolute-loader {
					position: absolute;
					bottom: 0;
					right: 0;
					z-index: 10;
				}

				&:after {
					content: "";
					position: absolute;
					top: 0;
					left: 0;
					width: 100%;
					height: 100%;
					border-radius: 13px;
					z-index: 0;
					background: transparent linear-gradient(180deg, #00000000 0%, #04264C00 38%, var(--color-primary) 100%) 0% 0% no-repeat padding-box;

					@media (max-width: 1650px) and (min-width: 1080px) {
						background: transparent linear-gradient(180deg, #00000000 0%, #04264C00 38%, var(--color-alpha-4) 100%) 0% 0% no-repeat padding-box;
					}
				}
			}
		}


		@media (max-width: 1650px) and (min-width: 1080px), (max-width: 420px) {
			flex-direction: column-reverse;
			align-items: center;
			justify-content: flex-end;

			.card-left, .card-right {
				width: 100%;
			}

			.card-left {
				padding-right: 0;
			}

			.card-right {
				height: 110px;
				margin-bottom: 15px;
			}

			.absolute-cta {
				display: none;
			}
		}

	}

	.card-upload {
		border: 1px solid #FCC700;
		background-color: var(--color-bg);
		position: relative;

		.most-popular {
			position: absolute;
			top: 20px;
			right: -10px;
			background: transparent linear-gradient(181deg, #FDC700 0%, #EABD0D 58%, #A29641 100%) 0% 0% no-repeat padding-box;
			color: var(--color-bg);
			font-size: 12px;
			font-weight: 500;
			padding: 4px 10px;
			border-radius: 20px;

			@media (max-width: 1080px) {
				padding: 4px 8px;
				font-size: 10px;
			}
		}

	}

	@media (max-width: 1080px) {
		.cards-inner-container {
			flex-direction: column;
		}

		.card {
			max-width: 100%;
			width: 100%;
		}

	}
}
</style>